import { useEffect } from "react";

const FacebookPixel = () => {
  useEffect(() => {
    // Main Facebook Pixel script
    const script1 = document.createElement("script");
    script1.type = "text/javascript";
    script1.textContent = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1708792329730256');
      fbq('track', 'PageView');
    `;
    document.body.appendChild(script1);

    return () => {
      // Cleanup script
      document.body.removeChild(script1);
    };
  }, []);

  return (
    <noscript>
      <img
        height="1"
        width="1"
        style={{ display: "none" }}
        src="https://www.facebook.com/tr?id=1708792329730256&ev=PageView&noscript=1"
        alt="Facebook Pixel"
      />
    </noscript>
  );
};

export default FacebookPixel;